import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appInternalLinks]',
})
export class InternalLinksDirective {
  constructor(private router: Router) {}

  @HostListener('click', ['$event']) onClick(event: Event) {
    const target = event.target as HTMLElement;

    if (target.tagName === 'A') {
      const HREF = target.getAttribute('href');

      if (HREF.includes('http')) {
        // Check if it's same with current page
        const hrefURL = new URL(HREF);

        const hostnames = ['localhost', 'icibot.app', 'guestservice.app'];

        if (hostnames.find((hostname) => hrefURL.hostname.includes(hostname))) {
          event.preventDefault();
          // Get the path of the HREF and navigate to it with router
          const PATH = hrefURL.pathname;
          this.router.navigate([PATH]);
        }
      }
    }
  }
}
